module.exports = __webpack_public_path__ + "img/4f5099d.jpg";